import { apiFetch } from "../utils/apiFetch";
import { API_BASE_OPERATOR as API_BASE } from "../config/vars";

export const fetchOperatorNews = async () => {
    const response = await apiFetch(`${API_BASE}/news/operator`);
    if (!response.ok) throw new Error("Не вдалося завантажити новини");
    return await response.json();
};

export const fetchUnreadOperatorNews = async () => {
    const res = await apiFetch(`${API_BASE}/news/operator/unread`);
    if (!res.ok) throw new Error("Не вдалося перевірити новини");
    return await res.json();
};

export const markOperatorNewsViewed = async () => {
    const res = await apiFetch(`${API_BASE}/news/operator/mark-viewed/news`, { method: "PUT" });
    if (!res.ok) throw new Error("Не вдалося позначити новини як переглянуті");
    return await res.json();
};

export const updateNewsItem = async (id, data) => {
    const response = await apiFetch(`${API_BASE}/news/operator/${id}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        const err = await response.json();
        throw new Error(err.detail || "Помилка оновлення Новини");
    }
    return await response.json();
};

export const createNewsItem = async (data) => {
    const response = await apiFetch(`${API_BASE}/news/operator`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        const err = await response.json();
        throw new Error(err.detail || "Помилка створення Новини");
    }
    return await response.json();
};
